module.exports = __webpack_public_path__ + "static/media/landingPage_Partner.6a1df646.md";